import { render, staticRenderFns } from "./ReportSection.vue?vue&type=template&id=0f0c6c76"
import script from "./ReportSection.vue?vue&type=script&lang=js"
export * from "./ReportSection.vue?vue&type=script&lang=js"
import style0 from "./ReportSection.vue?vue&type=style&index=0&id=0f0c6c76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports